import { useCallback, useState } from 'react'

export const useToggleState = (initial = false) => {
  const [state, setState] = useState<boolean>(initial)
  const toggle = useCallback(() => setState((s) => !s), [])
  return [state, toggle, setState] as const
}

export default useToggleState
